"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dashToPascalCase = (str) => str
    .toLowerCase()
    .split('-')
    .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
    .join('');
exports.camelToDashCase = (str) => str.replace(/([A-Z])/g, (m) => `-${m[0].toLowerCase()}`);
//# sourceMappingURL=case.js.map